// Lấy GitHub login mặc định của user qua `gh api user --jq .login`.
// Dùng làm default org khi user không truyền --repo-org.
import { spawnSync } from "node:child_process";

export function resolveGithubUsernameDefault(): string {
  // timeout 10s — tránh CLI treo vô hạn nếu GitHub API unreachable (captive portal,
  // proxy hỏng). spawnSync gửi SIGTERM khi quá hạn → status=null, signal="SIGTERM".
  const r = spawnSync("gh", ["api", "user", "--jq", ".login"], {
    encoding: "utf8",
    stdio: ["ignore", "pipe", "pipe"],
    timeout: 10_000,
  });
  if (
    r.signal === "SIGTERM" ||
    (r.error as NodeJS.ErrnoException | undefined)?.code === "ETIMEDOUT"
  ) {
    throw new Error(
      "Quá thời gian lấy GitHub username (10s). Kiểm tra mạng / kết nối GitHub rồi thử lại.",
    );
  }
  if (r.status !== 0) {
    throw new Error(`Không lấy được GitHub username: ${r.stderr?.trim()}`);
  }
  return r.stdout.trim();
}
